export class SetCollectionUserViewStatus {
    public static readonly type = '[JobsPlacements] Set collection user view status';

    constructor(public collectionId: number) { }
}
